import React, {useState} from 'react'
import UserMenu from './UserMenu'
import style from './style.module.scss'
import {connect} from "react-redux";
import {Select} from "antd";
import {withRouter} from "react-router-dom";
const { Option } = Select
const mapStateToProps = ({ settings, user }) => ({ settings, user })


const TopBar = ({settings, dispatch, location, user}) => {
    const [isFlareInternalUser, setIsFlareInternalUser] = useState(user.email.includes('@flarehr.com'))

    function handleUpdate(input) {

        dispatch({
            type: 'settings/CHANGE_SETTING',
            payload: {
                setting: 'environment',
                value: input,
            },
        })
    }

    function handleChangeWorkflowType(input) {

        console.log('input handleChangeWorkflowType', input)
        dispatch({
            type: 'settings/CHANGE_SETTING',
            payload: {
                setting: 'workflowType',
                value: input,
            },
        })
    }

  return (
    <div className={style.topbar}>
      <div className="mr-md-4 mr-auto">
        {/*<Search />*/}
      </div>
      <div className="mr-auto d-none d-md-block">
        {/*<IssuesHistory />*/}
      </div>
      <div className="mb-0 mr-4 d-xl-block d-none">
        {/*<Status />*/}
      </div>
      <div className="mr-4 d-none d-sm-block">
        {/*<LanguageSwitcher />*/}
      </div>
      <div className="mr-4 d-none d-sm-block">
        {/*<Actions />*/}
      </div>

        { (location.pathname === '/dashboard/workflows' || location.pathname === '/dashboard/invite') &&
        <div className="mr-3">
            <Select value={settings.workflowType} style={{ width: 120 }} onChange={handleChangeWorkflowType}>
                <Option value="pebts">
                    <strong className="text-capitalize text-success">PEBTS</strong>
                </Option>
                <Option value="pebtspo">
                    <strong className="text-capitalize text-success">PEBTSPo</strong>
                </Option>
                <Option value="pebspo">
                    <strong className="text-capitalize text-success">PEBSPo</strong>
                </Option>
                <Option value="pespo">
                    <strong className="text-capitalize text-success">PESPo</strong>
                </Option>
                <Option value="petspo">
                    <strong className="text-capitalize text-success">PETSPo</strong>
                </Option>
                <Option value="pbts">
                    <strong className="text-capitalize text-success">PBTS</strong>
                </Option>
                <Option value="pbtspo">
                    <strong className="text-capitalize text-success">PBTSPo</strong>
                </Option>
                <Option value="bts">
                    <strong className="text-capitalize text-success">BTS</strong>
                </Option>
                <Option value="pets">
                    <strong className="text-capitalize text-success">PETS</strong>
                </Option>
                <Option value="pebs">
                    <strong className="text-capitalize text-success">PEBS</strong>
                </Option>
                <Option value="pes">
                    <strong className="text-capitalize text-success">PES</strong>
                </Option>
                <Option value="ps">
                    <strong className="text-capitalize text-success">PS</strong>
                </Option>
                <Option value="bs">
                    <strong className="text-capitalize text-success">BS</strong>
                </Option>
                <Option value="super">
                    <strong className="text-capitalize text-success">Super</strong>
                </Option>
                <Option value="tax">
                    <strong className="text-capitalize text-success">Tax</strong>
                </Option>
                <Option value="benefits">
                    <strong className="text-capitalize text-success">Benefits</strong>
                </Option>
            </Select>
        </div>
        }


        {isFlareInternalUser &&
        <div className="mr-3">
            <Select value={settings.environment} style={{ width: 120 }} onChange={handleUpdate}>
                <Option value="sandbox">
                    <strong className="text-capitalize text-success">Sandbox</strong>
                </Option>
                <Option value="test">
                    <strong className="text-capitalize text-success">Test</strong>
                </Option>
                <Option value="autodev">
                    <strong className="text-capitalize text-success">Auto-dev</strong>
                </Option>
            </Select>
        </div>
        }


      <div className="">
        <UserMenu />
      </div>
    </div>
  )
}

export default withRouter(connect(mapStateToProps)(TopBar))

